import React from 'react'
import './Title.scss'


const Title = props => {

  return(
    <p className='Title'>{props.title}</p>
  )
}

export default Title